import React from "react";
import "./Category.css";

const SubCategory = ({ items }) => {
  return (
    <div className="row">
      <div className="category_main">
        <div className="col-md-4 p-0 col-12">
          <div className="category_img">
            <img src={items?.img} alt="" className="img-fliud" />
          </div>
        </div>
        <div className="col-md-8 col-12 padding_s  pt-3">
          <div className="subtitle">
            <h6>{items?.subTitle}</h6>
            <span className="heart">
              <i class="fas fa-heart"></i>
            </span>
          </div>
          <div className="titile">
            <h3>{items?.title}</h3>
          </div>
          <div className="subtitle">
            <h6 className="pb-0">{items?.details}</h6>
          </div>
          <div className="subtitle">
            <h6>{items?.subDetails}</h6>
          </div>
          <div className="mony_review">
            <div className="review">
              <p>
                <span className="category_star">
                  <i class="fas fa-star"></i>
                </span>
                <span className="review_number"> {items?.review}</span>
                <span className="review_total"> {items?.totalReview}</span>
              </p>
            </div>
            <div className="review">
              <p>
                <span className="category_price">{items?.price}</span>
                <br />
                <span className="totalPrice">{items?.totalPrice}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategory;
